var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3601 0L22.2386 19.8511H12.7317L16.9675 11.6239H16.7775C13.283 16.1751 8.06912 19.1712 0.640137 19.8511V11.7378C0.640137 11.7378 5.39263 11.4562 8.18649 8.50923H0.640137V0.000156805H9.12142V6.99874L9.31178 6.99796L12.7775 0.000156805H19.1917V6.95437L19.3821 6.95406L22.9778 0H32.3601Z",
    fill: "#435AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/Webflow.b4779310398e1d9f3129469053cb8d74.svg";
export { ForwardRef as ReactComponent };